import produce from 'immer';
import { DomainPreferences } from '../../api/types';
import { DashboardConfig } from '../../common/components/dashboards/types';
import { Languages } from '../../constants';
import { addMonth, format, monthEnd } from '../../utils-date';
import { ShipHealthcareDashboardChartConfig } from './shiphealthcare_dashboard_config';

export const ShipHealthcareFixedTimeFrameDashboardChartConfig: (
  domainPreferences: DomainPreferences,
  snapshotDate: number,
  id: string
) => DashboardConfig = (domainPreferences: DomainPreferences, snapshotDate: number, id: string) => {
  const formattedReportDate = format(monthEnd(addMonth(snapshotDate, -1)));
  const baseConfig = ShipHealthcareDashboardChartConfig(domainPreferences, snapshotDate);
  const updatedState = produce(baseConfig, (draft) => {
    draft.id = `shiphealthcare_custom_db_${id}`;
    draft.title = {
      [Languages.EN]: `Monthly Group Report (${formattedReportDate})`,
      [Languages.JA]: `SHIP人材諸表®（月次報告）(${formattedReportDate})`,
    };
    draft.pages.forEach((p) => (p.dashboardId = `shiphealthcare_custom_db_${id}`));
  });

  return updatedState;
};
